module.exports = __webpack_public_path__ + "static/media/foundry1_min.854fbe75728cfdcd0005dc9036452cc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/foundry1_min.jpg
// module id = 815
// module chunks = 1